import React, { useState, useEffect, useRef } from "react";
import Globe from "react-globe.gl";
import "./Travel.css";

const Travel = () => {
  const globeEl = useRef(null);
  const [arcsData, setArcsData] = useState([]);
  const [globeReady, setGlobeReady] = useState(false);

  // Coordinates for Iranian cities
  const cities = {
    mashhad: { name: "Mashhad", lat: 36.2981, lng: 59.6057 },
    babolsar: { name: "Babolsar", lat: 36.7025, lng: 52.6582 },
    tehran: { name: "Tehran", lat: 35.6892, lng: 51.389 },
    esfahan: { name: "Esfahan", lat: 32.6546, lng: 51.668 },
    kish: { name: "Kish", lat: 26.5321, lng: 53.9793 },
    geshm: { name: "Qeshm", lat: 26.8127, lng: 55.8911 },
    gorgan: { name: "Gorgan", lat: 36.8427, lng: 54.4415 },
    bandarAbbas: { name: "Bandar Abbas", lat: 27.1865, lng: 56.2808 },
  };

  // Create connections from Mashhad to other cities with grayscale colors
  useEffect(() => {
    const arcs = [
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.babolsar.lat,
        endLng: cities.babolsar.lng,
        color: "#aaaaaa",
        label: `${cities.mashhad.name} → ${cities.babolsar.name}`,
      },
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.tehran.lat,
        endLng: cities.tehran.lng,
        color: "#bbbbbb",
        label: `${cities.mashhad.name} → ${cities.tehran.name}`,
      },
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.esfahan.lat,
        endLng: cities.esfahan.lng,
        color: "#cccccc",
        label: `${cities.mashhad.name} → ${cities.esfahan.name}`,
      },
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.kish.lat,
        endLng: cities.kish.lng,
        color: "#dddddd",
        label: `${cities.mashhad.name} → ${cities.kish.name}`,
      },
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.geshm.lat,
        endLng: cities.geshm.lng,
        color: "#eeeeee",
        label: `${cities.mashhad.name} → ${cities.geshm.name}`,
      },
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.gorgan.lat,
        endLng: cities.gorgan.lng,
        color: "#cccccc",
        label: `${cities.mashhad.name} → ${cities.gorgan.name}`,
      },
      {
        startLat: cities.mashhad.lat,
        startLng: cities.mashhad.lng,
        endLat: cities.bandarAbbas.lat,
        endLng: cities.bandarAbbas.lng,
        color: "#aaaaaa",
        label: `${cities.mashhad.name} → ${cities.bandarAbbas.name}`,
      },
    ];

    setArcsData(arcs);
  }, []);

  // Focus on Iran when globe is ready
  useEffect(() => {
    if (globeReady && globeEl.current) {
      const scene = globeEl.current.scene();
      if (scene && scene.children) {
        const light = scene.children.find(
          (obj) => obj.type === "DirectionalLight"
        );
        if (light) {
          scene.remove(light);
        }
      }
      setTimeout(() => {
        // Set point of view to center on Iran
        globeEl.current.pointOfView({ lat: 32, lng: 53, altitude: 1.5 }, 100);
      }, 500);
    }
  }, [globeReady]);

  // Add points for cities with grayscale colors
  const pointsData = Object.values(cities).map((city) => ({
    lat: city.lat,
    lng: city.lng,
    name: city.name,
    color: city.name === "Mashhad" ? "#ffffff" : "#999999",
    radius: city.name === "Mashhad" ? 0.5 : 0.3,
  }));

  return (
    <div className="container">
      {/* <h1 className="travel-title">Travel Connections from Mashhad</h1>
      <p className="travel-info">
        Interactive visualization of flight connections from Mashhad to various
        cities across Iran. Hover over the lines and points to see more
        information.
      </p> */}
      <div className="globe-container">
        <Globe
          ref={globeEl}
          width={window.innerWidth}
          height={window.innerHeight}
          // Globe appearance - dark monochrome theme
          backgroundColor="#000000"
          globeImageUrl="//unpkg.com/three-globe@2.42.3/example/img/earth-dark.jpg"
          // Basic settings - minimal
          showGraticules={true}
          graticuleColor="#333333"
          showAtmosphere={false}
          // Arc properties - grayscale
          arcsData={arcsData}
          arcColor={"color"}
          arcLabel={"label"}
          arcDashLength={0}
          arcDashGap={0}
          arcDashAnimateTime={0}
          arcStroke={0.05}
          arcAltitude={0.05}
          arcAltitudeAutoScale={0.05}
          arcCurveResolution={64}
          arcCircularResolution={6}
          // Point properties - grayscale
          pointsData={pointsData}
          pointLabel="name"
          pointLat="lat"
          pointLng="lng"
          pointColor="color"
          pointRadius="radius"
          pointAltitude={0.01}
          pointsMerge={false}
          // Globe properties
          onGlobeReady={() => setGlobeReady(true)}
        />
      </div>
    </div>
  );
};

export default Travel;
